import Parse from 'parse';

Parse.initialize('atapp', 'j4,BeclAPSM{Egh1]PFf}6eUN');
Parse.serverURL = 'https://atapp.acrb.nl/parse';

console.log(Parse);


// WEBPACK FOOTER //
// ./src/config.js